// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-card-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .catalog-card-info {
    padding: 0 1rem;
    gap: 2rem;
  }
}
.catalog-card-info__header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (max-width: 768px) {
  .catalog-card-info__header {
    gap: 0.5rem;
  }
}
.catalog-card-info__header-brand {
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.4;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .catalog-card-info__header-brand {
    font-size: 0.875rem;
    line-height: 1.57;
  }
}
.catalog-card-info__header-name {
  font-weight: 400;
  font-size: 2rem;
  line-height: 1.5;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .catalog-card-info__header-name {
    font-size: 1.25rem;
    line-height: 1.4;
  }
}
.catalog-card-info__header-material {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-600));
}
.catalog-card-info__header-price {
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.4;
  color: rgba(var(--orange));
}
@media (max-width: 768px) {
  .catalog-card-info__header-price {
    font-size: 1rem;
    line-height: 1.625;
  }
}
.catalog-card-info__button {
  width: max-content;
  padding: 0.5rem 1rem !important;
}
.catalog-card-info__description {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-600));
}
.catalog-card-info__characteristics {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .catalog-card-info__characteristics {
    gap: 1rem;
  }
}
.catalog-card-info__characteristics-title {
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.3;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .catalog-card-info__characteristics-title {
    font-size: 1rem;
    line-height: 1.5;
  }
}
.catalog-card-info-characteristic {
  display: flex;
  gap: 1rem;
}
.catalog-card-info-characteristic__key {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
  color: rgba(var(--grey-600));
}
.catalog-card-info-characteristic__value {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
.catalog-card-info__like {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.catalog-card-info__like-header {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
.catalog-card-info__like-products {
  display: grid;
  grid-template-columns: repeat(auto-fill, 9.6875rem);
  justify-content: space-around;
  width: 100%;
  height: max-content;
  grid-gap: 1.5rem;
  column-gap: 1.125rem;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/components/CatalogCardInfo/styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AACE;EANF;IAOI,eAAA;IACA,SAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEJ;AAAI;EALF;IAMI,WAAA;EAGJ;AACF;AADI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AAGN;AADM;EANF;IAOI,mBAAA;IACA,iBAAA;EAIN;AACF;AADI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;AAGN;AADM;EAPF;IAQI,kBAAA;IACA,gBAAA;EAIN;AACF;AADI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAGN;AAAI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAEN;AAAM;EANF;IAOI,eAAA;IACA,kBAAA;EAGN;AACF;AACE;EACE,kBAAA;EACA,+BAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AADJ;AAGI;EALF;IAMI,SAAA;EAAJ;AACF;AAEI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;AAAN;AAEM;EAPF;IAQI,eAAA;IACA,gBAAA;EACN;AACF;AAGE;EACE,aAAA;EACA,SAAA;AADJ;AAGI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AADN;AAII;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;AAFN;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAMI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;AAJN;AAOI;EACE,aAAA;EACA,mDAAA;EACA,6BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AALN","sourcesContent":[".catalog-card-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  @media (max-width: 768px) {\n    padding: 0 1rem;\n    gap: 2rem;\n  }\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    @media (max-width: 768px) {\n      gap: 0.5rem;\n    }\n\n    &-brand {\n      font-weight: 400;\n      font-size: 1.25rem;\n      line-height: 1.4;\n      color: rgba(var(--grey-800));\n\n      @media (max-width: 768px) {\n        font-size: 0.875rem;\n        line-height: 1.57;\n      }\n    }\n\n    &-name {\n      font-weight: 400;\n      font-size: 2rem;\n      line-height: 1.5;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n        line-height: 1.4;\n      }\n    }\n\n    &-material {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.625;\n      color: rgba(var(--grey-600));\n    }\n\n    &-price {\n      font-weight: 400;\n      font-size: 1.25rem;\n      line-height: 1.4;\n      color: rgba(var(--orange));\n\n      @media (max-width: 768px) {\n        font-size: 1rem;\n        line-height: 1.625;\n      }\n    }\n  }\n\n  &__button {\n    width: max-content;\n    padding: 0.5rem 1rem !important;\n  }\n\n  &__description {\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.625;\n    color: rgba(var(--grey-600));\n  }\n\n  &__characteristics {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    @media (max-width: 768px) {\n      gap: 1rem;\n    }\n\n    &-title {\n      font-weight: 400;\n      font-size: 1.5rem;\n      line-height: 1.3;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n\n      @media (max-width: 768px) {\n        font-size: 1rem;\n        line-height: 1.5;\n      }\n    }\n  }\n\n  &-characteristic {\n    display: flex;\n    gap: 1rem;\n\n    &__key {\n      font-size: 1rem;\n      line-height: 1.625;\n      font-weight: 400;\n      color: rgba(var(--grey-600));\n    }\n\n    &__value {\n      font-size: 1rem;\n      line-height: 1.625;\n      font-weight: 400;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n    }\n  }\n\n  &__like {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    &-header {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n    }\n\n    &-products {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, 9.6875rem);\n      justify-content: space-around;\n      width: 100%;\n      height: max-content;\n      grid-gap: 1.5rem;\n      column-gap: 1.125rem;\n      box-sizing: border-box;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
